import React from "react";

interface CustomDropDownProps {
  children?: React.ReactNode;
  style?: React.CSSProperties;
  className?: string;
  'aria-labelledby'?: string;
}

// Custom menu component to handle click events properly
export const CustomDropDown = React.forwardRef<HTMLDivElement, CustomDropDownProps>(
  ({ children, style, className, 'aria-labelledby': labeledBy }, ref) => {
    return (
      <div
        ref={ref}
        style={style}
        className={`${className} dropdown-menu-custom`}
        aria-labelledby={labeledBy}
        onClick={(e) => e.stopPropagation()} // Prevent clicks inside from closing dropdown
      >
        {children}
      </div>
    );
  }
);

CustomDropDown.displayName = 'CustomDropDown';